import { useEffect, useState } from "react";
import axios from "axios";
import { FileText, ExternalLink, ImageOff } from "lucide-react";
import { API } from "../lib/api";

const PreviewBody = ({ meta, failed, url, isPdf, label }) => {
  if (!meta) return <div className="attach-empty"><ImageOff size={20} /> Tidak ada lampiran</div>;
  if (failed) return <div className="attach-empty">Gagal memuat lampiran</div>;
  if (!url) return <div className="attach-empty">Memuat...</div>;
  if (isPdf) return <div className="attach-empty"><FileText size={20} /> {meta.filename}</div>;
  return <a href={url} target="_blank" rel="noreferrer"><img src={url} alt={label} /></a>;
};

export const AttachmentPreview = ({ trxId, kind, label, meta }) => {
  const [url, setUrl] = useState("");
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    if (!meta) return undefined;
    let blobUrl = "";
    setUrl(""); setFailed(false);
    axios.get(`${API}/transactions/${trxId}/attachments/${kind}`, { responseType: "blob" })
      .then(r => { blobUrl = URL.createObjectURL(r.data); setUrl(blobUrl); })
      .catch(() => setFailed(true));
    return () => blobUrl && URL.revokeObjectURL(blobUrl);
  }, [trxId, kind, meta]);
  const isPdf = meta?.content_type === "application/pdf";
  return <div className="attach-preview" data-testid={`preview-${kind}`}>
    <span className="eyebrow">{label}</span>
    <PreviewBody meta={meta} failed={failed} url={url} isPdf={isPdf} label={label} />
    {url && <a className="text-link" data-testid={`open-${kind}`} href={url} target="_blank" rel="noreferrer"><ExternalLink size={13} /> Buka {isPdf ? "PDF" : "ukuran penuh"}</a>}
  </div>;
};
